import ObjectUtils from './object-utils';

export default {
	getFirstLettersByKey: function getFirstLettersByKey(arrayOfStrings, key) {
		var letters = [];
		for (var i = 0; i < arrayOfStrings.length; i++) {
			if (arrayOfStrings[i][key]) {
				var first = arrayOfStrings[i][key].replace(/["\""]+/g, '').charAt(0).toLowerCase();
				first = (!isNaN(parseInt(first,10)) ? '0-9' : first);
				if (letters.indexOf(first) === -1) {
					letters.push(first);
				}
			}
		}
		return letters.sort((nameA, nameB) => nameA.localeCompare(nameB));
	},

	getLettersByKey: function getLettersByKey(objArray, arraysOfLetters, key) {
		// ha objektumokon iteral vegig es a Name propertit hasonlitja, nagyon lassu
		// sztring tomb a kulcsertekekbol
		var keyArray = objArray.map(obj => obj[key]);
		// null elemek torlese
		var filteredKeyArray = keyArray.filter(stringValue => stringValue !== null);

		let letters =  [];
		let containNumber = false;

		filteredKeyArray.forEach(
			function(stringValue){
				if(stringValue) {
					let stringValueLowerCase = stringValue.toLowerCase();
					let firstLetter = stringValueLowerCase.charAt(0);
					let firstTwoLetters = stringValueLowerCase.substring(0, 2);
					let secondCharacter = stringValueLowerCase.charAt(1);

					//Ha a partner első 2 karaktere benne van a betű tömbben
					if (arraysOfLetters.includes(firstTwoLetters)) {
						letters.push(firstTwoLetters);
						//máskülönben ha az első betű benne van a betű tömbben vagy szám
					} else if (arraysOfLetters.includes(firstLetter) && isNaN(parseInt(firstLetter, 10))) {
						letters.push(firstLetter);
					} else if(firstLetter === '"' && arraysOfLetters.includes(secondCharacter)){
						letters.push(secondCharacter);
					} else if (!isNaN(parseInt(firstLetter, 10))) {
						containNumber = true;
					}
				}
		 });

		letters = [...new Set( letters.map(obj => obj)) ];

		// Számmal(0-9) kezdődő partnerek miatt kell ez a rész
		// első elemnek kell felvenni a 0-9 stringet hogy a listában ha van számmal kezdődő partner
		// azokat mutassa elsőnek, mint ahogy fent a karakter lista van
		if(containNumber){
			letters.unshift('0-9');
		}

		return letters;
	},

	filterByRegexAndKey: function (items, key, pattern) {
		items = items || [];

		return items.filter(function (item) {
			if (item[key].match(pattern)) {
				return item;
			}
		});
	},
	filterByKeyValue: function (items, key, value) {
		return items.filter(function (item) {
			var objectValue = key.match(/\./g) ? ObjectUtils.getValueByPath(item, key) : item[key];
			if (objectValue == value) {
				return item;
			}
		});
	},

	sumByKey: function (items, key) {
		var sum = 0;
		items.forEach(function (item) {
			sum += parseInt(item[key]);
		});
		return sum;
	},

	sumByPropertyValue: function (items, key, value, property) {
		var sum = 0;
		for (var i = 0; i < items.length; i++) {
			if (items[i][key] == value) {
				sum += isNaN(parseInt(items[i][property], 10)) ? 0 :  parseInt(items[i][property], 10);
			}
		}
		return sum;
	},

	getUniqueValues: function (items, key) {
		var flags = [], output = [], l = items.length, i;
		for (i = 0; i < l; i++) {
			if (flags[items[i][key]] || !items[i][key]) continue;
			flags[items[i][key]] = true;
			output.push(items[i][key]);
		}
		return output;
	},

	groupByKeyValues: function (items, values, key) {
		var output = {};
		for (var i = 0; i < values.length; i++) {
			for (var j = 0; j < items.length; j++) {
				if (items[j][key] == values[i]) {
					if (!output[values[i]]) {
						output[values[i]] = [];
					}
					output[values[i]].push(items[j]);
				}
			}
		}
		return output;
	},

	sortByKeysInt: function (items, key) {
		return items.sort(function (a, b) {
			a = parseInt(a[key]);
			b = parseInt(b[key]);
			return a - b;
		});
	},

	sortDescByKeysInt: function (items, key) {
		return items.reverse(function (a, b) {
			a = parseInt(a[key]);
			b = parseInt(b[key]);
			return a - b;
		});
	},

	sortByKey: function (items, key) {
		return items.sort(function (a, b) {
			var x = a[key].toLowerCase();
			var y = b[key].toLowerCase();

			return x < y ? -1 : x > y ? 1 : 0;
		});
	},

	sortDescByKey: function (items, key) {
		return items.sort(function (a, b) {
			var x = a[key].toLowerCase();
			var y = b[key].toLowerCase();

			return x > y ? -1 : x < y ? 1 : 0;
		});
	},

	removeItemByKeyValue: function (items, key, value) {
		for (var i = 0; i < items.length; i++) {
			if (items[i][key] == value) {
				items.splice(i, 1);
				break;
			}
		}
	}
};
